import React from 'react';
import { Row, Col } from 'react-bootstrap';

export default ({ session }) =>
    <Row className='margin-bottom-xs'>
        <Col md={12} lg={12} className='session-title custom-font font-size-24'>
            <span>
                {session?.title}
            </span>
        </Col>
    </Row>;
